const svgMainPath = "/svg/";
const pngMainPath = "/png/";
const imagesMainPath = "/images/";

class AppImages {
  // Logos
  static kSvgLogo = `${svgMainPath}logo.svg`;
  static kPngLogo = `${pngMainPath}logo.png`;

  // Partner Logos (OAuth)
  static kJohnDeereLogo = `${svgMainPath}john-deere_minimum.svg`;
  static kAgworldLogo = `${svgMainPath}agworld_minimum_white.svg`;

  // Landing Page Images
  static kBackgroundTractor = `${imagesMainPath}background_tractor.jpg`;
  static kAboutUs1 = `${imagesMainPath}about_us_1.jpg`;
  static kAboutUs2 = `${imagesMainPath}about_us_2.jpg`;
  static kAboutUs3 = `${imagesMainPath}about_us_3.jpg`;

  // Farmer Setup Images
  static kFarmerSetupBackground = `${imagesMainPath}background_tractor.jpg`;
}

export default AppImages;
export type AppImagesKeys = keyof typeof AppImages;
